import React, { useState, useEffect, useRef } from 'react';

import axios from 'axios';
import swal from 'sweetalert';
import { Link, Redirect } from 'react-router-dom'
import moment from 'moment';
import { MuiThemeProvider, createTheme } from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import { Drawer, Button, Space } from 'antd';
import SetColor from './SetColor.js';
import Dropzone from 'react-dropzone-uploader';
import { v1 as uuid } from 'uuid'
import 'react-dropzone-uploader/dist/styles.css'
import { Modal } from 'react-bootstrap';
import { setCookie, getCookie } from '../common_component/cookie.js';
import Organization_modal from '../common_component/organization_modal.js';
import Timer_modal from '../common_component/timer_modal.js';
import Select from 'react-select';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'

export const SaleList = () => {
    const timer_interval_ref = useRef();
    const [clockTimerModalShow, setClockTimerModalShow] = useState(false);
    let [state_org, setstate_org] = useState(2);
    let [organization_name, setOrganization_name] = useState("");
    let [user_name, setuser_name] = useState("");
    let [user_type, setuser_type] = useState("");
    const [OrganizationModalShow, setOrganizationModalShow] = useState(false);
    let [redirect_to_login, setRedirect_to_login] = useState(2);

    const [accessToken, setaccessToken] = useState('');
    let [user, setUser] = useState({});
    let [username, setUsername] = useState("");
    const [user_id, setUser_id] = useState("");
    const [unique_id, setUnique_id] = useState("");
    const [loading, setloading] = useState(false);
    let [state, setstate] = useState(2);
    const [userTheme, setUserTheme] = useState((localStorage.getItem("kt_metronic_theme_mode_menu") == "system") ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : localStorage.getItem("kt_metronic_theme_mode_menu"))
    //let [timer, setTimer] = useState(0);
    const timer = useRef(0)
    let [clock_timer, setClockTimer] = useState(0);

    const [startDate, setStartDate] = useState(moment.utc().subtract(6, "days").format("YYYY-MM-DD"))
    let [timezone_change, set_timezone_change] = useState("+00:00");
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"));
    const [User_role, setUser_role] = useState("");
    const [CurrencySymbol, setCurrencySymbol] = useState("");
    const [payment_id, setpayment_id] = useState("");
    const [submitButtonState, setSubmitButtonState] = useState(false);

    let [fileNames, setFileNames] = useState([])
    const [fileSessionUniqueId, setFileSessionUniqueId] = useState(uuid());
    const daterange_picker_ref = useRef();

    const [navtype, setnavtype] = useState("Overview");
    const [Dealer_name, setDealer_name] = useState("");
    const [Payment_details, setPayment_details] = useState(null);
    const [Bill_info, setBill_info] = useState([]);
    const [Payment_history_details, setPayment_history_details] = useState([]);
    const [open, setOpen] = useState(false);

    const [responsive, setResponsive] = useState("vertical");
    const [tableBodyHeight, setTableBodyHeight] = useState("400px");
    const [tableBodyMaxHeight, setTableBodyMaxHeight] = useState("");
    const [data, setData] = useState([]);
    const [editmodal, setEditModal] = useState([]);
    const [categoryid, setcategoryid] = useState("");
    const [categoryname, setCategoryname] = useState("");
    const [status, setstatus] = useState("");
    const [categorycode, setCategorycode] = useState("");
    const [description, setDescription] = useState("");
    const [globalsubcategory, setGlobalSubcategory] = useState([]);
    const [subcategory, setSubcategory] = useState([]);
    const [checkCode, setCheckCode] = useState({});
    const [issubcategory, setIssubcategory] = useState(false);
    const [visibility, setvisibility] = useState(0);
    let [redirect, setredirect] = useState(0);
    const [organization_id, setOrganization_id] = useState("");
    let [organization_list, setorganization_list] = useState([]);
    let [read, setread] = useState(2);
    let [write, setwrite] = useState(2);

    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);
    const [ImageModalShow, setImageModalShow] = useState(false);
    const [Image_src, setImage_src] = useState(false);

    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [sortColumn, setSortColumn] = useState(null)
    const [sortValue, setSortValue] = useState(null)
    const [searchValue, setSearchValue] = useState(null)
    const [saleListApiState, setSaleListApiState] = useState(false)

    const [profileName, setprofileName] = useState("")
    const [Item_flag, setItem_flag] = useState("")
    const [scheduleStartDate, setScheduleStartDate] = useState(moment().utc().format("YYYY-MM-DD"))
    const [scheduleEndDate, setScheduleEndDate] = useState(moment().utc().add(7, "days").format("YYYY-MM-DD"))
    const [frequencyDetails, setFrequencyDetails] = useState({ frequency: 1, time_period: "week", week_day: [], month_date: 1, month: 1 })
    const [allDayCheck, setAllDayCheck] = useState(true)
    const [startTime, setStartTime] = useState(new Date().getHours() + ":" + new Date().getMinutes())
    const [endTime, setEndTime] = useState((new Date().getHours() + 5) >= 23 ? "23:59" : (new Date().getHours() + 5) + ":" + new Date().getMinutes())

    const [RemoveAttachmentModalShow, setRemoveAttachmentModalShow] = useState(false);
    const [RemoveAttachmentDetails, setRemoveAttachmentDetails] = useState(null);
    const [MakeRecurringModalShow, setMakeRecurringModalShow] = useState(false);
    const [StatusModalShow, setStatusModalShow] = useState(false);


    var page_name = "sale-list";
    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    const onRowClick = async (rowData) => {
        setItem_flag(2);
        setOpen(true);
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/dealer-isd-sale-details`, { method: 'POST', body: JSON.stringify({ "id": rowData[0], "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        //var temp_dropdown = [];
        if (body.operation == "success") {
            setnavtype("Overview");
            setItem_flag(1);
            setPayment_details(body.data[0]);
            setCurrencySymbol(body.data[0].currency_details.Currency_symbol);
            setBill_info(body.data[0].Bill_info);
            setPayment_history_details(body.data[0].payment_history_details);

        }
        else if (body.operation == "danger") {
            if (body.message == "Authorization error") {
                setItem_flag(0);
            }
        }
    }

    const options = {
        fixedHeader: false,
        selectableRows: "none",
        responsive,
        tableBodyHeight,
        tableBodyMaxHeight,
        onRowClick: onRowClick,
        responsive: "standard",
    };

    let dropdownStyleDark = {
        option: (provided, state) => ({
            ...provided,
            color: '#dddddf',
            backgroundColor: state.isSelected ? provided.backgroundColor : state.isFocused ? '#5f5f8d' : provided.backgroundColor,
        }),
        control: (provided, state) => ({
            ...provided,
            backgroundColor: "#2b2b40",
            borderColor: "#4c4c71"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: "#dddddf",
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: "#dddddf",
        }),
        menu: (provided, state) => ({
            ...provided,
            backgroundColor: "#2b2b40",
        })
    }

    const columns = [
        {
            name: "payment_id",
            label: "payment_id",
            options: {
                display: false,
                filter: true,
                sort: true
            }
        },
        {
            name: "doc_number",
            label: "Doc Number",
            options: {
                filter: true,
                sort: true
            }
        },
        {
            name: "Payment_For",
            label: "Payment For",
            options: {
                filter: true,
                sort: true
            }
        },
        {
            name: "User",
            label: "User",
            options: {
                filter: true,
                sort: true
            }
        },
        {
            name: "invoice_number",
            label: "Invoice Number",
            options: {
                filter: true,
                sort: true
            }
        },
        {
            name: "Payment_Date",
            label: "Payment Date",
            options: {
                filter: true,
                sort: true
            }
        },
        {
            name: "Amount",
            label: "Amount",
            options: {
                filter: true,
                sort: true
            }
        },
        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "actions",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                download: false
            }
        }
    ];

    useEffect(() => {
        if (getCookie("access_token") != "") {
            if (getCookie("organization_id") != "") {
                setOrganization_id(getCookie("organization_id"));
            }
            else {
                var object = {};
                object.page_name = page_name;
                var headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "token": getCookie("access_token"),
                        "Accept": "*/*"
                    }
                }

                axios.post(`${process.env.REACT_APP_SERVER_URL}/show-organization`, object, headers).then((res) => {
                    if (res.data.length == 1) {
                        setCookie('organization_id', res.data[0].organization_id, 1, true);
                        setOrganization_id(res.data[0].organization_id)
                    }
                    else {
                        setstate_org(1);
                        setorganization_list(res.data);
                        setOrganizationModalShow(true);
                    }
                })
            }
        }
        else {
            setRedirect_to_login(1);
        }
    }, [])

    useEffect(() => {
        setCookie("lastpage", window.location.href, 1, false)
        const validateJWT = () => {

            if (getCookie("access_token") != "") {
                var object = {};
                object.token = getCookie("access_token");

                var headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "*/*"
                    }
                }
                axios.post(`${process.env.REACT_APP_SERVER_URL}/get-user`, object, headers).then((res) => {

                    if (res.data.operation == "success") {
                        var user_object = {};
                        user_object.email = res.data.email;
                        user_object.name = res.data.name;
                        user_object.img = res.data.img;
                        setUser_id(user_object.email)
                        setUser(user_object)
                        setUsername(res.data.name)
                    }
                    else {
                        swal("Session Expired!", "Please login to continue using.", "warning").then((value) => {
                            window.location.href = "/login"
                        });
                    }
                })
                    .catch(function (error) {
                        swal("Session Expired!", "Please login to continue using.", "warning").then((value) => {
                            window.location.href = "/login"
                        });
                    });
                object.organization_id = organization_id;
                axios.post(`${process.env.REACT_APP_SERVER_URL}/audience-info`, object, headers).then((res) => {

                    if (res.data.operation == "success") {
                        var token = res.data.audience_license;
                        if (res.data.organization_flag == 0) {
                            setstate_org(3);
                            setOrganization_name(res.data.organization_name);
                            setOrganizationModalShow(true);
                        }
                        else {
                            setuser_name(res.data.user_type.name);
                            setuser_type(res.data.user_type.type);
                            var path = window.location.pathname;
                            path = path.replace(/\/$/, "");
                            path = decodeURIComponent(path);
                            var original_url = path.split("/")[1]
                            let index = 0;
                            let temp = -1;
                            for (let i = 0; i < res.data.user_access.access.length; i++) {
                                if (temp == 1) break;
                                let component = res.data.user_access.access[i].inside_components;
                                for (let j = 0; j < component.length; j++) {
                                    if (temp == 1) break;
                                    if (component[j].hasOwnProperty(original_url)) {
                                        index = i;
                                        if (component[j][original_url] == 1 && res.data.user_access.access[index].visibility == 1) {
                                            temp = 1;
                                            setvisibility(1);
                                            setread(component[j]["read"])
                                            setwrite(component[j]["write"])
                                            // setwrite(0)
                                            // break;
                                        }
                                        else {
                                            setredirect(1);
                                        }
                                    }
                                    else if (component[j].hasOwnProperty("key")) {
                                        let sub_inside_components = component[j].inside_components
                                        for (let k = 0; k < sub_inside_components.length; k++) {
                                            if (sub_inside_components[k].hasOwnProperty(original_url)) {
                                                index = i
                                                if (sub_inside_components[k][original_url] == 1 && res.data.user_access.access[index].visibility == 1 && component[j].visibility == 1) {
                                                    temp = 1;
                                                    setvisibility(1);
                                                    setread(sub_inside_components[k]["read"])
                                                    setwrite(sub_inside_components[k]["write"])
                                                    // setwrite(0)
                                                    break;

                                                }
                                                else {
                                                    setredirect(1);
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        temp = 2;
                                    }
                                }
                            }

                            if (temp == 2) {
                                setredirect(1);
                            }

                        }
                        if (!token.includes("ufhdsupw29fher") || !token.includes("pdbwu27dh6schs") || !token.includes("0dh27agiqbcrwi")) {
                            setCookie('access_token', res.data.audience_license, 1, true)
                            timer.current = process.env.REACT_APP_JWT_EXPIRY;
                            //setClockTimer(process.env.REACT_APP_JWT_EXPIRY);
                        }
                        else {
                            timer.current = res.data.audience_count;
                            //setClockTimer(res.data.audience_count)
                        }
                    }
                    else {
                        setRedirect_to_login(1);
                    }
                })
                    .catch(function (error) {
                        setRedirect_to_login(1);
                    });
            }
            else {
                setRedirect_to_login(1);
            }
        }
        organization_id != "" && validateJWT();
    }, [organization_id])

    useEffect(() => {
        let id = setInterval(() => {
            setUserTheme((localStorage.getItem("kt_metronic_theme_mode_menu") == "system") ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : localStorage.getItem("kt_metronic_theme_mode_menu"))
        }, 10)

        return () => {
            clearInterval(id)
        }
    }, [])

    useEffect(() => {
        timer_interval_ref.current = setInterval(() => {
            // console.log(timer)

            timer.current = timer.current - 1
            if (timer.current > 0 && timer.current < process.env.REACT_APP_JWT_EXPIRY_NOTICE) {
                if (!clockTimerModalShow) {
                    setClockTimer(process.env.REACT_APP_JWT_EXPIRY_NOTICE)
                    setClockTimerModalShow(true)
                }
            }
        }, 1000);

        return () => { clearInterval(timer_interval_ref) };
    }, []);

    const onClose = () => {
        setOpen(false);
        setPayment_history_details([]);
        setCurrencySymbol("");
        setPayment_details(null);
    };


    async function getSaleList(cp, rpp, sort_c, sort_v, search_v, startDate, endDate) {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/show-dealer-isd-sale`, { method: 'POST', body: JSON.stringify({ "email": user.email, "organization_id": organization_id, "start_date": startDate, "end_date": endDate, "current_page": cp, "rows_per_page": rpp, "sort_column": sort_c, "sort_value": sort_v, "search_value": search_v, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.data.list.length > 0) {
            setstate(1);
            setEditModal(body.data.list);
            setListCount(body.data.count);
            setSaleListApiState(false);
        }
        else {
            setstate(0);
        }
    }

    async function getUserRole() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-user-role`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            let user_details = body.data[0].user_details;
            setUser_role(body.data[0].user_role);
            if (body.data[0].user_role === "DSO") {
                //setSelectedDsoUser({ label: user_details.name + " - " + user_details.user_id, value: user_details.user_id });
            }
        }
        else {
            throw "transaction series api list error"
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {

            let p1 = getSaleList(currentPage, rowsPerPage, sortColumn, sortValue, searchValue, startDate, endDate);
            let p2 = getUserRole();

            Promise.all([p1, p2])
                .then(() => {
                    //setstate(4)
                    console.log("all apis done")
                })
                .catch((err) => {
                    //setstate(3)
                    console.log(err)
                })
        }

    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            getSaleList(currentPage, rowsPerPage, sortColumn, sortValue, searchValue, startDate, endDate)
        }
    }, [currentPage, rowsPerPage, sortColumn, sortValue, searchValue])

    const trimDecimalPlaces = (amt, decimal_place) => {
        return Math.round(amt * Math.pow(10, decimal_place)) / Math.pow(10, decimal_place)
    }

    useEffect(() => {
        async function geteditdetails() {
            if (editmodal.length > 0) {
                var temp_data = [];
                editmodal.map((obj) => {
                    var temp_obj = {};
                    temp_obj.payment_id = obj.unique_id;
                    temp_obj.doc_number = obj.doc_number;
                    temp_obj.Payment_For = obj.Payment_for;
                    temp_obj.User = obj.payment_user_name;
                    temp_obj.invoice_number = obj.invoice_number;
                    temp_obj.Amount = <>{obj.currency_details.Currency_symbol} {trimDecimalPlaces(obj.item_list.reduce((p, o) => { return p + Number(o.selling_price) }, 0), obj.currency_details.decimal_place)}</>
                    temp_obj.Payment_Date = moment(obj.sale_date).format('ll');
                    let status = obj.log_status;
                    if (status === "PENDING_APPROVAL") {
                        temp_obj.status = <span className="badge badge-light-warning">Pending</span>
                    }
                    else if (status === "DRAFT") {
                        temp_obj.status = <span className="badge badge-secondary">Draft</span>
                    }
                    else if (status === "cancelled") {
                        temp_obj.status = <span className="badge badge-danger">Cancelled</span>
                    }
                    else {
                        temp_obj.status = <span className="badge badge-success">{status}</span>
                    }

                    temp_obj.id = obj.unique_id;
                    var id = obj.unique_id;
                    temp_obj.actions =
                        <div className="dropdown">
                            <button onClick={(e) => { e.stopPropagation() }} className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="fas fa-bars px-0"></i>
                            </button>
                            {(write && obj.sale_modify_flag == true && status !== "cancelled") &&
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    {obj.Payment_for == "Dealer" ? <li className="py-1"><Link to={`/edit-dealer-sale-entry/${id}`} className="dropdown-item">Edit details</Link></li>
                                        :
                                        <li className="py-1"><Link to={`/edit-isd-sale-entry/${id}`} className="dropdown-item">Edit details</Link></li>
                                    }
                                    <li className="py-1"><a onClick={(e) => { e.stopPropagation(); updateStatus(id); setStatusModalShow(true); }} className="dropdown-item">Cancel</a></li>
                                </ul>
                            }
                        </div>

                    temp_data.push(temp_obj);
                })
                setstate(1);
                setData(temp_data);
            }
            else {
                setData([]);
            }
        }
        geteditdetails();

    }, [editmodal])

    const approvePaymentSubmit = (final_flag, cancel_flag, cancel_msg, id) => {

        var object = {};

        object.final_flag = final_flag
        object.cancel_flag = cancel_flag
        object.cancel_msg = cancel_msg
        object.unique_id = id
        object.user_email = user.email
        object.user_role = User_role

        object.organization_id = organization_id
        object.page_name = page_name;

        console.log(object);
        setSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/approve-payment-details`, object, headers).then((res) => {
            setSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", "Payment reviewed approved successfully!", "success").then(() => { window.location.reload() })
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const makeRecurring = (id) => {
        for (let i = 0; i < editmodal.length; i++) {
            if (id == editmodal[i].unique_id) {
                setpayment_id(id);
                setMakeRecurringModalShow(true);
            }
        }
    }

    const updateStatus = (id) => {
        for (let i = 0; i < editmodal.length; i++) {
            if (id == editmodal[i].unique_id) {
                setpayment_id(id);
                setstatus(editmodal[i].log_status);
                setStatusModalShow(true);
            }
        }
    }

    function getExtension(path) {
        var basename = path.split(/[\\/]/).pop(),  // extract file name from full path ...
            // (supports `\\` and `/` separators)
            pos = basename.lastIndexOf(".");       // get last position of `.`

        if (basename === "" || pos < 1)            // if file name is empty or ...
            return "";                             //  `.` not found (-1) or comes first (0)

        return basename.slice(pos + 1);            // extract extension ignoring `.`
    }

    const Preview = ({ fileWithMeta: { remove }, meta }) => {
        const { name, percent, status, previewUrl } = meta;
        // console.log(name)
        return (

            <div className="preview-box">
                <img src={previewUrl} style={{ maxHeight: "80px", maxWidth: "80px", borderRadius: "4px", marginRight: "10px" }} />
                <span title={name} className="name">{name.length >= 10 ? name.slice(0, 10) + "...." : name}</span> - <span className="status">{(status === "done") ? "Successfully Uploaded" : status}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span> && <span className="dzu-previewButton remove" onClick={remove} >
                    <svg version="1.1" width="16" height="16" viewBox="0 0 122.88 122.88">
                        <g>
                            <path className="st0" d="M1.63,97.99l36.55-36.55L1.63,24.89c-2.17-2.17-2.17-5.73,0-7.9L16.99,1.63c2.17-2.17,5.73-2.17,7.9,0 l36.55,36.55L97.99,1.63c2.17-2.17,5.73-2.17,7.9,0l15.36,15.36c2.17,2.17,2.17,5.73,0,7.9L84.7,61.44l36.55,36.55 c2.17,2.17,2.17,5.73,0,7.9l-15.36,15.36c-2.17,2.17-5.73,2.17-7.9,0L61.44,84.7l-36.55,36.55c-2.17,2.17-5.73,2.17-7.9,0 L1.63,105.89C-0.54,103.72-0.54,100.16,1.63,97.99L1.63,97.99z" />
                        </g>
                    </svg>
                </span>}
                {
                    status === "done" &&
                    <span className="dzu-previewButton remove" onClick={remove} >
                        <svg version="1.1" width="16" height="16" viewBox="0 0 122.88 122.88">
                            <g>
                                <path className="st0" d="M1.63,97.99l36.55-36.55L1.63,24.89c-2.17-2.17-2.17-5.73,0-7.9L16.99,1.63c2.17-2.17,5.73-2.17,7.9,0 l36.55,36.55L97.99,1.63c2.17-2.17,5.73-2.17,7.9,0l15.36,15.36c2.17,2.17,2.17,5.73,0,7.9L84.7,61.44l36.55,36.55 c2.17,2.17,2.17,5.73,0,7.9l-15.36,15.36c-2.17,2.17-5.73,2.17-7.9,0L61.44,84.7l-36.55,36.55c-2.17,2.17-5.73,2.17-7.9,0 L1.63,105.89C-0.54,103.72-0.54,100.16,1.63,97.99L1.63,97.99z" />
                            </g>
                        </svg>
                    </span>
                }
            </div>
        )
    }

    const handleChangeStatus2 = ({ meta }, status, allFiles) => {
        const { name } = meta;

        if (status === 'done') {
            setMainSubmitButtonState(false)
            setFileNames([...fileNames, name])
        }
        else if (status === 'removed') {
            setMainSubmitButtonState(false)
            let temp = [...fileNames]
            temp.splice(temp.indexOf(name), 1)
            setFileNames(temp)
        }
        else if (status === "error_file_size") {
            allFiles[0].remove()
            swal("Oops!", "File size exceeded", "warning");
        }
    };

    const getUploadParams2 = ({ file }) => {

        const body = new FormData();
        body.append('dataFiles', file);
        body.append('unique_id', fileSessionUniqueId);
        body.append('organization_id', organization_id);
        body.append('user_id', user.email);
        body.append('page_name', page_name);

        let headers = {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
            "token": getCookie("access_token")
        }

        setMainSubmitButtonState(true)
        return { url: `${process.env.REACT_APP_SERVER_URL}/upload-dealer-isd-sale-documents`, headers, body }
    }


    const showImage = (src) => {
        //console.log(src);
        setImage_src(src);
        setImageModalShow(true);
    }

    const submitattachments = (val) => {
        var values = { "payment_id": val, "unique_id": fileSessionUniqueId, 'filenames': fileNames, "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/save-dealer-isd-sale-document-details`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Payment attachments saved successfully!", "success").then((value) => {
                    window.location.reload();
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    const removeattachments = (val) => {
        let image_id = RemoveAttachmentDetails.unique_id;
        let file_name = RemoveAttachmentDetails.file_name;
        let original_file_name = RemoveAttachmentDetails.original_file_name;
        var values = { "image_id": image_id, "file_name": file_name, "original_file_name": original_file_name, "folder": "sale_documents", "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/delete-dealer-isd-sale-document`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Expense attachments removed successfully!", "success").then((value) => {
                    window.location.reload();
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    const submitStatus = (e) => {
        e.preventDefault();

        var values = { "id": payment_id, "save_flag": true, "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/cancel-dealer-isd-sale-details`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Collection cancelled successfully!", "success").then((value) => {
                    window.location.reload();
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    return (
        <>
            {
                (redirect == 1 || (read == 0 && write == 0)) ?
                    <>
                        <Redirect to={{
                            pathname: "/unauthorized",
                        }}
                        />
                    </> :
                    null
            }
            <div className="d-flex flex-column flex-column-fluid">
                <div className="app-toolbar py-3 py-lg-6" id="kt_app_toolbar">
                    <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Sale List

                            <small className="text-muted fs-7 fw-bold my-1 ms-1"></small>
                        </h1>
                        <div className="d-flex align-items-center gap-2 gap-lg-3">
                            <div className="m-0">
                                {user_type === "Dealer" ?
                                    <Link to="/dealer-sale-entry" className="btn btn-sm btn-primary me-3 rounded">
                                        <span className="svg-icon svg-icon-2">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor"></rect>
                                                <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"></rect>
                                            </svg>
                                        </span>
                                        Dealer Sale Entry</Link>
                                    :
                                    <Link to="/isd-sale-entry" className="btn btn-sm btn-primary me-3 rounded">
                                        <span className="svg-icon svg-icon-2">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor"></rect>
                                                <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"></rect>
                                            </svg>
                                        </span>
                                        ISD Sale Entry</Link>}

                            </div>
                        </div>
                    </div>
                </div>
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    <div id="kt_app_content_container" className="app-container container-xxl">
                        <div className="card">
                            <div className="card-body pt-6">
                                {
                                    state == 1 ?
                                        <>
                                            <div className="d-flex align-items-center gap-5 mx-5 my-2">
                                                {/* <div className='fw-bold fs-5'>Select Date Range</div> */}
                                                <div className='d-flex'>
                                                    <DateRangePickerComponent
                                                        ref={daterange_picker_ref}
                                                        allowEdit={false}
                                                        focus={(e) => {
                                                            //console.log(e);
                                                            daterange_picker_ref.current.show()
                                                        }}
                                                        delayUpdate={true}
                                                        change={(e) => {
                                                            setStartDate(e.startDate);
                                                            setEndDate(e.endDate);
                                                            var days = moment(e.endDate).diff(moment(e.startDate), 'days');
                                                            getSaleList(currentPage, rowsPerPage, sortColumn, sortValue, searchValue, e.startDate, e.endDate);
                                                        }}
                                                        startDate={startDate}
                                                        endDate={endDate}
                                                    />
                                                </div>
                                            </div>
                                            <MuiThemeProvider theme={createTheme({ palette: { type: userTheme } })}>
                                                <MUIDataTable
                                                    title={
                                                        <>
                                                            <span className='me-20'>Sale List</span>
                                                            {saleListApiState && <><span>Loading...</span><div className="spinner-grow text-dark" style={{ width: "1rem", height: "1rem" }}></div></>}
                                                        </>
                                                    }
                                                    data={data}
                                                    columns={columns}
                                                    options={{
                                                        ...options,
                                                        download: false,
                                                        filter: false,
                                                        searchPlaceholder: 'Search Brands',
                                                        serverSide: true,
                                                        count: listCount,
                                                        jumpToPage: true,
                                                        onChangePage: (val) => { setCurrentPage(val) },
                                                        onChangeRowsPerPage: (val) => { setCurrentPage(0); setRowsPerPage(val) },
                                                        onColumnSortChange: (col, dir) => { setSortColumn(col); setSortValue(dir) },
                                                        onSearchChange: (val) => { setCurrentPage(0); setSearchValue(val) },
                                                        // onTableChange: (action, tableState)=>{console.log(action, tableState);}
                                                    }}
                                                />
                                            </MuiThemeProvider>
                                        </>
                                        :
                                        <>
                                            {
                                                state == 2 ?
                                                    <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                                    :
                                                    <>
                                                        <div className="card-body pt-0">
                                                            <div className="text-gray-500 fw-bold fs-5 mb-5">Sale List</div>

                                                            <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                                                <div className="d-flex flex-stack flex-grow-1">
                                                                    <div className="fw-bold">
                                                                        <h4 className="text-gray-800 fw-bolder">No Data Available.</h4>
                                                                        <div className="fs-6 text-gray-600"> </div>
                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>
                                                    </>
                                            }
                                        </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={ImageModalShow} onHide={() => { setImageModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title></Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setImageModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {/* <div className="form-group row"> */}
                    {/* <div className="col-lg-12"> */}
                    <img src={Image_src} style={{ height: "300px", padding: '25px', marginTop: '0' }} />
                    {/* </div> */}
                    {/* </div> */}
                </Modal.Body>
                {/* <Modal.Footer>  */}
                {/* <button type="button" onClick={(e) => {setImageModalShow(false)}} className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button> */}
                {/* {write==1 &&<form >
						<button type="button" onClick={(e) => { submitStatus(e) }} className="btn btn-danger"  data-kt-indicator={mainSubmitButtonState?"on":"off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Cancel</span>
						<span className="indicator-progress">Please wait...
							<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
					</form>} */}
                {/* </Modal.Footer> */}
            </Modal>
            <Modal show={RemoveAttachmentModalShow} onHide={() => { setRemoveAttachmentModalShow() }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Delete Expense Attachments</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setRemoveAttachmentModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="col-lg-12">
                            <h3>Are you sure you want to delete this Expense Attachments?</h3>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setRemoveAttachmentModalShow(false) }} className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    {write == 1 && <form >
                        <button type="button" onClick={(e) => { removeattachments(e) }} className="btn btn-danger" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Delete</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>
            <Modal show={StatusModalShow} onHide={() => { setStatusModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Cancel Sale Details</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setStatusModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="col-lg-12">
                            Current Status is : {status === "PENDING_APPROVAL" ?
                                <span className="badge badge-light-warning">Pending</span>
                                :
                                status === "DRAFT" ?
                                    <span className="badge badge-secondary">Draft</span>
                                    :
                                    <span className="badge badge-success">{status}</span>
                            }<br />
                            <h3>Are you sure about cancelling Sale details?</h3>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {/* <button type="button" onClick={(e) => {setStatusModalShow(false)}} className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button> */}
                    {write == 1 && <form >
                        <button type="button" onClick={(e) => { submitStatus(e) }} className="btn btn-danger" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Cancel</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>
            <Drawer title={Dealer_name} width={window.innerWidth > 1200 ? 800 : 'auto'} bodyStyle={{ padding: "1.5rem" }} onClose={onClose} open={open} closeIcon={<a onClick={onClose}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="38px" height="38px"><path fill="#f44336" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" /><path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z" /><path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z" /></svg>
            </a>}
                extra={
                    <Space>
                        {/* <Button onClick={onClose} type="primary">Close</Button> */}
                        <div className="dropdown">
                        </div>
                    </Space>
                }

            >
                {Item_flag === 1 ?
                    <>
                        <div className="card">
                            <div className="d-flex w-100 overflow-auto">
                                <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
                                    <li className="nav-item mx-lg-1">
                                        <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Overview" && "active"}`} onClick={(e) => { setnavtype("Overview"); }}>Overview</a>
                                    </li>
                                    <li className="nav-item mx-lg-1" role="presentation">
                                        <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Transactions" && "active"}`} onClick={(e) => { setnavtype("Transactions"); }}>Item</a>
                                    </li>
                                    <li className="nav-item mx-lg-1" role="presentation">
                                        <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Attachments" && "active"}`} onClick={(e) => { setnavtype("Attachments"); }}>Attachments</a>
                                    </li>
                                    <li className="nav-item mx-lg-1" role="presentation">
                                        <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "History" && "active"}`} onClick={(e) => { setnavtype("History"); }}>History</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="card">
                            {navtype === "Overview" ?
                                <>
                                    <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                        <div className="card-title m-0">
                                            <h3 className="fw-bold m-0">Overview</h3>
                                        </div>
                                        {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                                    </div>
                                    {Payment_details != null &&
                                        <div className="card-body p-9">
                                            <div className="row mb-3">
                                                <label className="col-lg-4 fw-semibold text-muted">Document Number</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-bold fs-6 text-gray-800">{Payment_details.doc_number}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-lg-4 fw-semibold text-muted">Payment Date</label>
                                                <div className="col-lg-8 fv-row">
                                                    <span className="fw-semibold text-gray-800 fs-6">{moment(Payment_details.payment_date).format("ll")}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-lg-4 fw-semibold text-muted">Amount</label>
                                                <div className="col-lg-8 fv-row">
                                                    <span className="fw-semibold text-gray-800 fs-6">{Payment_details.currency_details.Currency_symbol} {trimDecimalPlaces(Payment_details.item_list.reduce((p, o) => { return p + Number(o.selling_price) }, 0), Payment_details.currency_details.decimal_place)}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-lg-4 fw-semibold text-muted">Payment For</label>
                                                <div className="col-lg-8 fv-row">
                                                    <span className="badge badge-light-primary">{Payment_details.Payment_for}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-lg-4 fw-semibold text-muted">User</label>
                                                <div className="col-lg-8 fv-row">
                                                    <span className="fw-semibold text-gray-800 fs-6">{Payment_details.payment_user_name}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-lg-4 fw-semibold text-muted">Status
                                                </label>
                                                <div className="col-lg-8 d-flex align-items-center">
                                                    {Payment_details.log_status === "PENDING_APPROVAL" ?
                                                        <span className="badge badge-light-warning">Pending</span>
                                                        :
                                                        Payment_details.log_status === "DRAFT" ?
                                                            <span className="badge badge-secondary">Draft</span>
                                                            :
                                                            Payment_details.log_status === "DRAFT" ?
                                                                <span className="badge badge-secondary">Draft</span>
                                                                :
                                                                Payment_details.log_status === "cancelled" ?
                                                                    <span className="badge badge-danger">Cancelled</span>
                                                                    :
                                                                    <span className="badge badge-success">{Payment_details.log_status}</span>
                                                    }
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-lg-4 fw-semibold text-muted">Currency</label>
                                                <div className="col-lg-8 fv-row">
                                                    <span className="fw-semibold text-gray-800 fs-6">{`${Payment_details.currency_details.Currency_code}`}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-lg-4 fw-semibold text-muted">Customer Name</label>
                                                <div className="col-lg-8 fv-row">
                                                    <span className="fw-semibold text-gray-800 fs-6">{`${Payment_details.customer_details[0].customer_display_name}`}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-lg-4 fw-semibold text-muted">Customer Mobile</label>
                                                <div className="col-lg-8 fv-row">
                                                    <span className="fw-semibold text-gray-800 fs-6">{`${Payment_details.customer_details[0].phone}`}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-lg-4 fw-semibold text-muted">Customer Billing Address</label>
                                                <div className="col-lg-8 fv-row">
                                                    {(Payment_details.customer_details[0].billing_address !== null && Payment_details.customer_details[0].billing_address !== undefined) && <span className="fs-6 fw-semibold text-gray-600">{`${Payment_details.customer_details[0].billing_address.city} ${Payment_details.customer_details[0].billing_address.state}, ${Payment_details.customer_details[0].billing_address.pincode} ${Payment_details.customer_details[0].billing_address.country}`}</span>}
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-lg-4 fw-semibold text-muted">Customer Shipping Address</label>
                                                <div className="col-lg-8 fv-row">
                                                    {(Payment_details.customer_details[0].shipping_address !== undefined && Payment_details.customer_details[0].shipping_address !== null) && Payment_details.customer_details[0].shipping_address.length > 0 ? (
                                                        <span className="fs-6 fw-semibold text-gray-600">{`${Payment_details.customer_details[0].shipping_address[0].city} ${Payment_details.customer_details[0].shipping_address[0].state}, ${Payment_details.customer_details[0].shipping_address[0].pincode} ${Payment_details.customer_details[0].shipping_address[0].country}`}</span>
                                                    ) : (
                                                        <span className="fs-6 text-muted">No shipping address given</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-lg-4 fw-semibold text-muted">Reference</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-semibold fs-6 text-gray-800">{Payment_details.ref}</span>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </>
                                :
                                navtype === "Transactions" ?
                                    <>
                                        <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                            <div className="card-title m-0">
                                                <h3 className="fw-bold m-0">Item Details</h3>
                                            </div>
                                            {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                                        </div>
                                        {Payment_details != undefined &&
                                            <div className="card-body p-9">
                                                <div className="table-responsive">
                                                    <table className="table align-middle">
                                                        <tbody>
                                                            {
                                                                Payment_details.item_list.map((obj3, indx3) => {
                                                                    return (
                                                                        // obj3.payment_info.length>0 &&
                                                                        <>
                                                                            <tr>
                                                                                <td className="bg-light rounded text-gray-600 fs-8 fw-bold px-3 py-2" colspan="4">
                                                                                    Product Name : <span class="badge badge-primary fs-base">{obj3.product_name}</span></td>
                                                                            </tr>
                                                                            <tr>
                                                                                {/* <td className="fs-6 fw-bold text-gray-800">
                                                                {obj4.brand.label}</td> */}
                                                                                <td className="fs-6 fw-bold text-gray-400">
                                                                                    Quantity
                                                                                    <span className="text-gray-800"> {obj3.quantity}</span>
                                                                                </td>
                                                                                <td className="fs-6 fw-bold text-gray-400">
                                                                                    MOP Price:
                                                                                    <span className="text-gray-800"> {Payment_details.currency_details.Currency_symbol} {obj3.mop_price}</span>
                                                                                </td>
                                                                                <td className="fs-6 fw-bold text-gray-400">
                                                                                    Selling Price:
                                                                                    <span className="text-gray-800"> {Payment_details.currency_details.Currency_symbol} {obj3.selling_price}</span>
                                                                                </td>
                                                                                <td className="fs-6 fw-bold text-gray-400">
                                                                                    Total:
                                                                                    <span className="text-gray-800"> {Payment_details.currency_details.Currency_symbol} {Number(obj3.quantity) * Number(obj3.selling_price)}</span>
                                                                                </td>
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        }
                                    </>
                                    :
                                    navtype === "Attachments" ?
                                        <>
                                            <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                                <div className="card-title m-0">
                                                    Attachments
                                                </div>
                                            </div>
                                            {Payment_details != undefined &&
                                                <div className="card-body p-9">
                                                    <div className="overflow-auto pb-5">
                                                        <div className="d-flex align-items-center border border-dashed border-gray-300 rounded min-w-700px p-7">
                                                            {Payment_details.document_details.length > 0 &&
                                                                Payment_details.document_details.map((obj, index) => {
                                                                    return (
                                                                        <>
                                                                            {/* {console.log(getExtension(obj.file_name))} */}
                                                                            {getExtension(obj.file_name) == "pdf" ?
                                                                                <div className="d-flex flex-aligns-center pe-10 pe-lg-20">
                                                                                    <img alt="" className="w-30px me-3" src="/assets/media/svg/files/pdf.svg" />
                                                                                    <div className="ms-1 fw-semibold">
                                                                                        <a target="_blank" href={(`${process.env.REACT_APP_GENERAL_DOCUMENT_BUCKET}`).concat("/isms/sale_documents/", (obj.file_name))} className="fs-6 text-hover-primary fw-bold">{obj.original_file_name.substring(0, obj.original_file_name.lastIndexOf('.'))}</a>
                                                                                        <div className="text-gray-400">1.9mb</div>
                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                <div className="overlay me-10">
                                                                                    <div className="overlay-wrapper">
                                                                                        <img alt="img" className="rounded w-150px" src={(`${process.env.REACT_APP_GENERAL_DOCUMENT_BUCKET}`).concat("/isms/sale_documents/", (obj.file_name))} />
                                                                                    </div>
                                                                                    <div className="overlay-layer bg-dark bg-opacity-10 rounded">
                                                                                        <a onClick={() => showImage((`${process.env.REACT_APP_GENERAL_DOCUMENT_BUCKET}`).concat("/isms/sale_documents/", (obj.file_name)))} className="btn btn-sm btn-primary btn-shadow me-1">View</a>
                                                                                        <a onClick={() => { setRemoveAttachmentDetails(obj); setRemoveAttachmentModalShow(true) }} className="btn btn-sm btn-danger btn-shadow">Delete</a>
                                                                                    </div>
                                                                                </div>}
                                                                        </>
                                                                    )
                                                                })}
                                                        </div>
                                                    </div>
                                                    <div className="mb-2">
                                                        <Dropzone
                                                            getUploadParams={getUploadParams2}
                                                            onChangeStatus={handleChangeStatus2}
                                                            //LayoutComponent={CustomLayout}
                                                            PreviewComponent={Preview}
                                                            styles={{
                                                                dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                                                inputLabelWithFiles: { margin: '20px 3%' }
                                                            }}
                                                            maxFiles={3}
                                                            maxSizeBytes={1024 * 1024 * 2}
                                                            accept="image/*,.pdf"
                                                        />
                                                    </div>
                                                    <div className="text-end mb-1">
                                                        {fileNames.length > 0 && <button type="button" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} onClick={(e) => submitattachments(Payment_details.unique_id)} className="btn btn-sm btn-primary me-2">
                                                            Save</button>}
                                                    </div>
                                                </div>
                                            }
                                        </>
                                        :
                                        navtype === "History" &&
                                        <>
                                            <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                                <div className="card-title m-0">
                                                    History
                                                </div>
                                            </div>
                                            {Payment_details != undefined &&
                                                <div className="card-body p-9">
                                                    {Payment_history_details.length > 0 && Payment_history_details.map((obj, index) => {
                                                        return (
                                                            <>
                                                                <div className="m-0">
                                                                    <div className="d-flex align-items-sm-center mb-5">
                                                                        <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                                                                            <div className="flex-grow-1 me-2">
                                                                                {obj.operation === "insert" ? <span className="badge badge-lg badge-secondary fw-bold my-2">Created</span> : obj.operation === "cancelled" ? <span className="badge badge-lg badge-danger fw-bold my-2">Cancelled</span> : obj.operation === "voucher_creation" ? <><span className="badge badge-lg badge-success fw-bold my-2">Voucher Created</span><a href={`/dealer-master-voucher-summary/${obj.master_voucher_id}`} className="text-primary fw-bold me-1"> #{obj.master_voucher_name}</a></> : <span className="badge badge-lg badge-primary fw-bold my-2">Updated</span>}
                                                                                {/* <span className="text-gray-800 fw-bold d-block fs-4">{obj.operation === "voucher_creation" &&<>#<a href="#" className="text-primary fw-bold me-1">#{OBJ.MASTER_VOUCHER_NAME}</a></>}</span> */}
                                                                            </div>

                                                                            {/* <span className="badge badge-lg badge-light-success fw-bold my-2">Delivered</span> */}
                                                                        </div>
                                                                    </div>
                                                                    <div className="timeline">
                                                                        <div className="timeline-item align-items-center mb-7">
                                                                            <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                                            <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                                                <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                                                <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                                                            </svg>
                                                                            </span>
                                                                            <div className="timeline-content m-0">
                                                                                <span className="fs-6 text-gray-400 fw-semibold d-block">Date</span>
                                                                                <span className="fs-6 fw-bold text-gray-800">{moment(obj.log_date_time).format("lll")} </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="timeline-item align-items-center">
                                                                            <div className="timeline-line w-40px"></div>
                                                                            <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                                                <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                                                <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                                            </svg>
                                                                            </span>
                                                                            <div className="timeline-content m-0">
                                                                                <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                                                <span className="fs-6 fw-bold text-gray-800">{obj.user_id}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {Payment_history_details.length > 1 &&
                                                                    <div className="separator separator-dashed my-6"></div>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            }
                                        </>
                            }
                        </div>
                    </>
                    :
                    Item_flag == 2 ?
                        <div className="card">
                            <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                        </div>
                        :
                        Item_flag == 0 &&
                        <div className="card">
                            <div class="pt-10 pb-0"><h3 class="text-dark text-center fw-bolder">Authorization error</h3>
                                <div class="text-center text-gray-600 fw-bold pt-1">There have some Authorization error.You need to LogIn further</div><div class="text-center mt-5 mb-9">
                                    <a onClick={(e) => { setRedirect_to_login(1); }}>Log In</a>
                                </div>
                            </div>
                        </div>
                }
            </Drawer>
            <Organization_modal OrganizationModalShow={OrganizationModalShow} setOrganizationModalShow1={setOrganizationModalShow} organization_name={organization_name} organization_list={organization_list} organization_id={organization_id} state_org={state_org} mainSubmitButtonState={mainSubmitButtonState} setMainSubmitButtonState={setMainSubmitButtonState} />
            <Timer_modal clockTimerModalShow={clockTimerModalShow} setClockTimerModalShow1={setClockTimerModalShow} clock_timer={clock_timer} organization_id={organization_id} timer_ref={timer} mainSubmitButtonState={mainSubmitButtonState} setMainSubmitButtonState={setMainSubmitButtonState} />
        </>);

};

export default SaleList;
